export enum FlowKey {
    GAF = 'GAF',
    RAF = 'RAF',
    EXISTING_GRANTEE_LIMITED = 'EXISTING_GRANTEE_LIMITED',
    NEW_GRANTEE_LIMITED = 'NEW_GRANTEE_LIMITED',
    NEW_GRANTEE_INFO_ONLY = 'NEW_GRANTEE_INFO_ONLY',
    NON_VG_CLIENT_LIMITED = 'NON_VG_CLIENT_LIMITED',
    NON_VG_CLIENT_INFO_ONLY = 'NON_VG_CLIENT_INFO_ONLY',
    TEST = 'TEST',
}
// TODO: add keys for NVC flow in separate story
